module.exports = __webpack_public_path__ + "img/travel.5f0c25e2.png";